module.exports = __webpack_public_path__ + "static/media/more-options.f2099494.svg";